import { CashCount } from "../CashCount";
import { CashDetail } from "../CashDetail";
import { MachineBag } from "../cashFlow/MachineBag";

export class MachineContent {
    /** Nome dell'installazione a cui appartiene la macchina di cui si sta definendo lo stato*/
    machineInstallationName: string = null;

    /** Serial number della macchina a cui ci si sta riferendo */
    machineSerialNumber: string = null;

    /** Machine model */
    model: string = null;

    /** Machine content  */
    content: CashCount = null;

    /** Ultimo aggiornamento dello stato di questa macchina */
    lastUpdate: Date = null;

    thresholdAlerts: CashDetail[] = [];

    machineBags: MachineBag[] = [];

    constructor() {}

    public parse(obj: any) {
        if (obj.MachineInstallationName) this.machineInstallationName = obj.MachineInstallationName;
        if (obj.MachineSerialNumber) this.machineSerialNumber = obj.MachineSerialNumber;
        if (obj.Content) {
            this.content = new CashCount();
            this.content.parse(obj.Content);
        }

        if (obj.Timestamp) this.lastUpdate = obj.Timestamp;

        if (obj.ThresholdAlerts) {
            this.thresholdAlerts = [];
            obj.ThresholdAlerts.forEach((t) => {
                var cc = new CashDetail();
                cc.parse(t);
                this.thresholdAlerts.push(cc);
            });
        }

        if (obj.MachineBags) {
            this.machineBags = [];
            obj.MachineBags.forEach((t) => {
                var cc = new MachineBag();
                cc.parse(t);
                this.machineBags.push(cc);
            });
        }
    }
}
